module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2fsm5"))).then(() => parcelRequire('hEqeo'));